import styled from 'styled-components';
import Wra16A from 'dc/Wra16A';
import { Typ20 } from 'dc/Typ';
import APH120B from 'dc/APH120B';
import { ShortWrapper } from '../elements';

export const Wrapper = styled(ShortWrapper)`
  background: #fff;
`;

export const HeaderWrapper = styled(Wra16A)`
  width: 100%;
`;

export const Header = styled(APH120B)`
  > i {
    color: #7a4e94;
  }
`;

export const TextWrapper = styled(Wra16A)`
  background: #7a4e94;
  width: 100%;
`;

export const Text = styled(Typ20)`
  color: #fff;
`;
